import { styled } from 'styled-components';
import DestinationMoreInfo from './DestinationMoreInfo';
import DestinationMap from './DestinationMap';
import { tk, Typography } from '@sunwebgroup/ui-components';
import { useCMSPageField } from '@/cms/fields';

const Flex = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${tk('spacing_md')};
  margin-top: ${tk('spacing_lg')};

  @media ${tk('mq_desktop_sm')} {
    flex-direction: row;
  }
`;

const FlexElement = styled.div`
  width: 100%;
  height: 160px;

  &:first-child {
    flex: none;
  }

  @media ${tk('mq_desktop_sm')} {
    height: 280px;

    &:first-child {
      width: 280px;
    }
  }
`;

export default function DestinationSection() {
  const moreInfo = useCMSPageField('PDP.DestinationInformation');

  return (
    <div>
      {moreInfo?.sectionTitle && <Typography $variant="heading-md">{moreInfo.sectionTitle}</Typography>}
      <Flex>
        <FlexElement>
          <DestinationMap />
        </FlexElement>
        <FlexElement>{moreInfo && <DestinationMoreInfo moreInfo={moreInfo} />}</FlexElement>
      </Flex>
    </div>
  );
}
